const categories = [
  {
    icon: 'ri-home-heart-line',
    color: '#5C5470',
    title: '家庭保障規劃',
    desc: '協助家庭依照成員結構、收入責任與照護需求，建立整體風險防護網。',
    outcomes: ['家庭收入中斷保障', '子女醫療保障配置', '父母照護風險規劃', '家庭保障缺口診斷'],
  },
  {
    icon: 'ri-heart-pulse-line',
    color: '#FF8C69',
    title: '個人醫療保險',
    desc: '針對個人健康風險、職業特性與預算，規劃適合的醫療保障組合。',
    outcomes: ['住院醫療保障', '重大疾病保障', '實支實付規劃', '意外醫療補強'],
  },
  {
    icon: 'ri-file-search-line',
    color: '#D4A373',
    title: '保單健檢與缺口分析',
    desc: '整理現有保單，找出重複投保、保障不足或費率偏高的問題，提供調整建議。',
    outcomes: ['現有保單全面盤點', '重複投保識別', '保障缺口分析', '年度定期追蹤'],
  },
  {
    icon: 'ri-building-4-line',
    color: '#5C5470',
    title: '企業團體方案',
    desc: '協助企業規劃員工保障福利，提升員工安心感與企業留才競爭力。',
    outcomes: ['員工團體保險規劃', '健康福利方案設計', '企業主保障規劃', '定期方案檢視更新'],
  },
];

export default function TestimonialsCategories() {
  return (
    <section className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            SERVICE CATEGORIES
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            見證分類
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-4"></div>
          <p className="text-gray-600 max-w-lg mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            不同背景的客戶，有不同的保障需求與服務重點
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {categories.map((cat) => (
            <div
              key={cat.title}
              className="bg-white rounded-2xl p-7 border border-transparent hover:border-[#D4A373]/30 hover:-translate-y-1 transition-all duration-300"
              style={{ boxShadow: '0 2px 12px 0 rgba(92,84,112,0.05)' }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${cat.color}18` }}
              >
                <i className={`${cat.icon} text-2xl`} style={{ color: cat.color }}></i>
              </div>

              <h3
                className="font-serif font-bold text-[#5C5470] mb-3"
                style={{ fontSize: 'clamp(1.125rem, 1.4vw, 1.25rem)', lineHeight: '1.45' }}
              >
                {cat.title}
              </h3>

              <p className="text-gray-600 mb-5" style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}>
                {cat.desc}
              </p>

              <ul className="space-y-2">
                {cat.outcomes.map((o) => (
                  <li key={o} className="flex items-center gap-2 text-gray-500" style={{ fontSize: '1rem' }}>
                    <span
                      className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ backgroundColor: cat.color }}
                    ></span>
                    {o}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
